export enum searchDataActionTypes {
    SetProductsType = "SET_PRODUCTS",
}

export const setSearchData = (products: any) => ({
    type: searchDataActionTypes.SetProductsType,
    payload: products
});

